import FairOrders from './FairOrders.jsx';
import FairOrdersClosed from './FairOrdersClosed.jsx';
import FairOrdersCanceled from './FairOrdersCanceled.jsx';
import FairOrdersOfBusiness from './FairOrdersOfBusiness.jsx';

export { FairOrders, FairOrdersClosed, FairOrdersCanceled, FairOrdersOfBusiness }


// WEBPACK FOOTER //
// ./pages/fair/fair-orders/index.js